import type { FC, MouseEvent } from 'react';
import styles from './StrategySelector.module.css';

const stopPropagation = (e: MouseEvent) => e.stopPropagation();

interface StrategySelectorControlsProps {
  onSelectAll: () => void;
  onDeselectAll: () => void;
}

export const StrategySelectorControls: FC<StrategySelectorControlsProps> = ({ onSelectAll, onDeselectAll }) => (
  <div className={styles.selectorControls} onClick={stopPropagation}>
    <button type="button" className={styles.controlButton} onClick={onSelectAll}>
      Select All
    </button>
    <button type="button" className={styles.controlButton} onClick={onDeselectAll}>
      Deselect All
    </button>
  </div>
);
